module.exports = __webpack_public_path__ + "img/dvi.736d7234.svg";